// Drawola mindmap — fork-only types and constants.
//
// `customData.drawolaMindmap` on a rectangle marks it as a mindmap node so
// future overlay / layout code can identify nodes and walk the tree without
// any new element type in the upstream library.

export const MINDMAP_DATA_KEY = "drawolaMindmap" as const;

export type MindmapSide = "L" | "R" | null;
export type PlusDirection = "T" | "B" | "L" | "R";

export type MindmapNodeData = {
  __drawolaKind: "mindmapNode";
  mindmapId: string;
  nodeId: string;
  parentId: string | null;
  side: MindmapSide;
};

// Root block sizes (visually larger and tinted to distinguish from regular
// blocks per MindMeister convention).
export const MINDMAP_ROOT_WIDTH = 240;
export const MINDMAP_ROOT_HEIGHT = 80;

// Regular (non-root) block sizes.
export const MINDMAP_CHILD_WIDTH = 200;
export const MINDMAP_CHILD_HEIGHT = 60;

// Layout gaps.
export const MINDMAP_NODE_GAP = 40;
export const MINDMAP_HORIZONTAL_GAP = 80;
export const MINDMAP_VERTICAL_GAP = 24;

// Step size when shifting a freshly inserted root rightward to clear other
// elements at the viewport center.
export const MINDMAP_RIGHT_SHIFT_STEP =
  MINDMAP_ROOT_WIDTH + MINDMAP_NODE_GAP;
